import React from 'react';
import { FullScreenPageNoButton } from '../FullScreenButtonPage';
import { ReactComponent as ChatErrorIcon } from '../../resources/images/chat-error-connection.svg';
import { makeStyles, useTheme } from '@material-ui/core';
import { styleBreakMobile, styleBreakSmallMobile, styleBreakDesktop, CONTENT_MIN_WIDTH } from '../utilities/layouts/Globals';

const useStyles = makeStyles(theme => ({
    box: {
        paddingTop: theme.spacing(8),
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    title: {
        marginBottom: theme.spacing(2),
        fontWeight: 700,
        lineHeight: 1.3,
        letterSpacing: '0.3px',
        margin: 'auto',
        [styleBreakMobile(theme)]: {
            textAlign: 'center',
            maxWidth: theme.spacing(36.25),
            fontSize: theme.spacing(4) - 2,
        },
        [styleBreakDesktop(theme)]: {
            maxWidth: '100%',
            textAlign: 'center',
            fontSize: theme.spacing(2.5),
            margin: '0px 40px',
        },
    },
    message: {
        textAlign: 'left',
        letterSpacing: '0.16px',
    },
    titleEmp: {
        color: theme.palette.primary.main,
    },
}));

function TitleText() {
    const classes = useStyles();
    return (
        <h2 data-cy="text_chat_error_title" className={classes.title}>
            Sorry, We're Having Trouble
            <span className={classes.titleEmp}> Loading </span>
            Watchman Chat
        </h2>
    );
}

export default function ChatConnectionErrorPage({ onReconnect, reconnecting }) {
    const message = 'Please try again later or contact Watchman support.';
    const buttonText = 'Connect to Chat';
    const theme = useTheme();

    // FullScreenPageNoButton can accept override styles
    const stylesOverride = {
        root: {
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-around',
            overflowX: 'hidden',
            [styleBreakMobile(theme)]: {
                paddingTop: theme.spacing(2),
                justifyContent: 'flex-start',
            },
            [styleBreakDesktop(theme)]: {
                height: '100%',
            },
        },
        contentLayoutDiv: {
            [styleBreakMobile(theme)]: {
                height: 'calc(100vh - 150px)',
                paddingTop: '48px',
            },
            [styleBreakDesktop(theme)]: {
                height: '100%',
                minHeight: '526px',
            },
        },
        body: {
            [styleBreakSmallMobile(theme)]: {
                maxWidth: theme.spacing(37),
            },
            [styleBreakDesktop(theme)]: {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
            },
        },
        icon: {
            [styleBreakMobile(theme)]: {
                width: theme.spacing(54),
                height: theme.spacing(27.25),
            },
            [styleBreakSmallMobile(theme)]: {
                width: theme.spacing(47.75),
                height: theme.spacing(20.375),
            },
            [styleBreakDesktop(theme)]: {
                height: theme.spacing(21.625),
                width: '115%',
            },
        },
        shadowedIcon: {
            alignItems: 'center',
            [styleBreakMobile(theme)]: {
                marginTop: 0,
                marginBottom: 0,
            },
        },
        shadow: {
            marginTop: theme.spacing(2),
            height: theme.spacing(4),
            [styleBreakMobile(theme)]: {
                width: theme.spacing(26.5),
            },
            [styleBreakDesktop(theme)]: {
                width: theme.spacing(21.875),
            },
        },
        button: {
            [styleBreakDesktop(theme)]: {
                minWidth: 'calc(100% - 30px)',
                marginLeft: '15px',
                marginRight: '15px',
                marginBottom: '20px',
            },
        },
        bodyText: {
            [styleBreakDesktop(theme)]: {
                textAlign: 'center',
                marginLeft: '30px',
                marginRight: '30px',
            },
        },
        fullscreenButtonPageHorizontalPaddingOverride: {
            [styleBreakDesktop(theme)]: {
                minWidth: CONTENT_MIN_WIDTH - theme.spacing(6),
                height: '100%',
            },
        },
    };
    return (
        <FullScreenPageNoButton
            stylesOverride={stylesOverride}
            Icon={ChatErrorIcon}
            SubtitleText={TitleText}
            bodyText={message}
            buttonText={buttonText}
            onButtonClick={onReconnect}
            showButton={true}
            showShadow={true}
            loadingButton={reconnecting}
        />
    );
}
